module.exports = __webpack_public_path__ + "img/2025-10-15a_5.b61e5d0d.jpg";